var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.014 352H399.986C441.607 352 463.48 302.371 435.359 271.619L259.373 79.48C249.873 69.168 236.938 64.012 224 64.012C211.064 64.012 198.127 69.168 188.627 79.48L12.641 271.619C-15.48 302.246 6.393 352 48.014 352ZM223.863 112.027C223.877 112.023 223.928 112.012 224 112.012L223.977 111.9L399.986 304L48.037 304.039L223.863 112.027ZM424 400H24C10.746 400 0 410.744 0 424C0 437.254 10.746 448 24 448H424C437.256 448 448 437.254 448 424C448 410.744 437.256 400 424 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEject);
export default __webpack_public_path__ + "static/media/eject.5e18c2157f00f9ff2cc49c85bb2bd92a.svg";
export { ForwardRef as ReactComponent };